import React from 'react';

import plus_cyan_light from '../../../assets/plus-thick-cyan.svg';
import plus_cyan_dark from '../../../assets/plus-thick-cyan-dark.svg';
import plus_magenta from '../../../assets/plus-thick-magenta.svg';
import minus_cyan_light from '../../../assets/minus-thick-cyan.svg';
import minus_cyan_dark from '../../../assets/minus-thick-cyan-dark.svg';
import minus_magenta from '../../../assets/minus-thick-magenta.svg';
import minus_mnt from '../../../assets/minus-mnt.svg';
import minus_mnt_hover from '../../../assets/minus-mnt-hover.svg';
import plus_mnt from '../../../assets/plus-thick-mnt.svg';
import plus_mnt_hover from '../../../assets/plus-thick-mnt-hover.svg';

import './drawerSectionContainer.scss';

const DrawerSectionContainer = ({ children, moduleExpanded, handleClick, light, site }) => {
    const minus_cyan = light ? minus_cyan_light : minus_cyan_dark;
    const plus_cyan = light ? plus_cyan_light : plus_cyan_dark;

    return (
        <div className={`drawer-container ${site}`} onClick={handleClick}>
            {children}
            {site == 'mnt' ? 
                (
                    <div className='section-expand-icon'>
                        {
                            moduleExpanded ? 
                            <>
                                <img className='minus mnt icon' src={minus_mnt} />
                                <img className='minus mnthover icon' src={minus_mnt_hover} />
                            </>
                            :
                            <>
                                <img className='plus mnt icon' src={plus_mnt} />
                                <img className='plus mnthover icon' src={plus_mnt_hover} />
                            </>
                        }
                    </div>
                ) :
                (
                    <div className='section-expand-icon'>
                        {
                            moduleExpanded ? 
                            <>
                                <img className='minus cyan icon' src={minus_cyan} />
                                <img className='minus magenta icon' src={minus_magenta} />
                            </>
                            :
                            <>
                                <img className='plus cyan icon' src={plus_cyan} />
                                <img className='plus magenta icon' src={plus_magenta} />
                            </>
                        }
                    </div>
                )
            }
        </div>
    );
};

export default DrawerSectionContainer;